module.exports = __webpack_public_path__ + "static/media/egg.e8f89332.svg";